import { BulkInvitePayload, BulkInviteResponse, UserSettings } from '../types';

import AuthRequests from './auth.requests';

class UserRequests {
  static bulkInvite(data: BulkInvitePayload, companyId: string) {
    return AuthRequests.axiosInstance.post<BulkInviteResponse>(
      '/1.1/invitations/bulk',
      data,
      {
        params: { company: companyId },
      },
    );
  }

  static updateSettings(companyId: string, settings: Partial<UserSettings>) {
    return AuthRequests.axiosInstance.put(
      '/1.0/users/me',
      settings,
      {
        params: { company: companyId },
      },
    );
  }
}

export default UserRequests;
